import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, Avatar, useTheme } from '@material-ui/core';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';
import { IdeaCss } from '../IdeaCss';
import { history } from '../../../helpers';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';

export function IdeaContributors() {
  const theme = useTheme();
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { hasIdeaFlux } = useIdeaDetailsController();

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.cardSmall}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <GroupIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">{t('participantes')}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            {hasIdeaFlux.contributors?.length > 0 && hasIdeaFlux.contributors.map((contributor, index) => (
              <Box display="flex" alignItems="center" marginBottom="1rem" key={index}>
                {contributor.attachment?.url ? (
                  <Avatar
                    className={classes.contributorImage}
                    src={contributor.attachment?.url}
                  />
                ) : (
                  <Avatar
                    className={classes.contributorImage}
                    style={{ backgroundColor: theme.palette.primary.light }}
                  >
                    <PersonIcon style={{ color: theme.palette.primary.main }} />
                  </Avatar>
                )}
                <Typography
                  variant="subtitle2"
                  className={classes.contributorName}
                  onClick={() => history.push(`/profile/${contributor._id}`)}
                >
                  {contributor.name}
                </Typography>
              </Box>
            ))}
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}
